module.exports = __webpack_public_path__ + "a98626e1aef6ceba5dfc1ee7112e235a.ttf";


//////////////////
// WEBPACK FOOTER
// ./client/fonts/Montserrat-Medium.ttf
// module id = 1899
// module chunks = 0